import { useState } from "react";
import { useTheme } from "../../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import baseURL from "../../../../../configs/api";
import axios from 'axios';
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import PleaseWaitPopup from "../../../../PleaseWaitPopup";
import colorConfigs from "../../../../../configs/colorConfigs";
import useAuth from "../../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../../components/hooks/useTenant";

export const AddExpenseTypes = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { themeStyles } = useTheme();
    const navigate = useNavigate();
    const [expenseTypeName, setExpenseTypeName] = useState<string>("");
    const [isActive, setIsActive] = useState<string>("No");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!pleaseWaitPopup) {
            setPleaseWaitPopup(true);

            axios
                .post(
                    `${baseURL}vehicleExpenseType?userId=${auth?.id}`,
                    JSON.stringify({
                        expenseTypeName,
                        isActive: isActive === "Yes",
                    }),
                    {
                        headers: {
                            'X-Tenant-ID': tenantId,
                            "Content-Type": "application/json"
                        },
                        withCredentials: true,
                    }
                )
                .then(() => {
                    setPleaseWaitPopup(false);
                    navigate(-1);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        }
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>

                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Expense Type</h2>
                                </div>
                            </div>

                            <div className="mt-2 p-2">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full px-2">
                                        <div className="grid grid-cols-3 gap-6">
                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Expense Type Name</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={expenseTypeName}
                                                        onChange={(e) => setExpenseTypeName(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                                                    <RadioGroup
                                                        row
                                                        value={isActive}
                                                        onChange={(e) => setIsActive(e.target.value)}
                                                    >
                                                        <FormControlLabel
                                                            value="Yes" control=
                                                            {<Radio
                                                                sx={{
                                                                    color: "gray",
                                                                    "&.Mui-checked": {
                                                                        color: "#167AC3",
                                                                    },
                                                                }}
                                                            />} label="Yes"
                                                            sx={{
                                                                color: themeStyles.form.labelTextColor
                                                            }}
                                                        />
                                                        <FormControlLabel value="No" control={
                                                            <Radio
                                                                sx={{
                                                                    color: "gray",
                                                                    "&.Mui-checked": {
                                                                        color: "#167AC3",
                                                                    },
                                                                }}
                                                            />} label="No"
                                                            sx={{
                                                                color: themeStyles.form.labelTextColor
                                                            }}
                                                        />
                                                    </RadioGroup>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex gap-4 mt-6">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                type="submit"
                                            >
                                                Save
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => navigate(-1)}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    )
}
